//features/auth/PersistLogin.js
import { Outlet, useNavigate } from "react-router-dom"
import { useEffect, useRef, useState } from 'react'
import { useRefreshMutation } from "./authApiSlice"
import usePersist from "../../hooks/usePersist"
import { useSelector } from 'react-redux'
import { selectCurrentToken } from "./authSlice"
import PulseLoader from 'react-spinners/PulseLoader'

const PersistLogin = () => {
    const [persist] = usePersist()
    const token = useSelector(selectCurrentToken)
    const navigate = useNavigate()
    const effectRan = useRef(false)

    const [isLoading, setIsLoading] = useState(true)

    const [refresh, { isError, error }] = useRefreshMutation()

    useEffect(() => {
        if (effectRan.current === true || process.env.NODE_ENV !== 'development') {
            const verify = async () => {
                try {
                    if (!token && persist) {
                        await refresh().unwrap()
                    }
                } catch (err) {
                    navigate('/login', { replace: true })
                } finally {
                    setIsLoading(false)
                }
            }
            verify()
        }
        return () => { effectRan.current = true }
    }, [token, persist, refresh, navigate])

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 bg-dark">
                <PulseLoader color="#FFF" size={15} />
            </div>
        )
    }

    if (isError) {
        navigate('/login', { replace: true })
        return null
    }

    return <Outlet />
}

export default PersistLogin